import * as channelReducers from './ChannelReducers';
import * as messageReducers from './MessageReducers';
import * as otherReducers from './OtherReducers';
import * as userReducers from './UserReducers';
import * as memberReducers from './MemberReducers';
import * as twilioReducers from './TwilioReducers';
import { initialState } from '../state';
import { Types } from '../actions';
export function chatReducer(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        // chat-service
        case Types.UPDATE_IDENTITY:
            return memberReducers.updateIdentity(state, action);
        case Types.UPDATE_RECIPIENT_ID:
            return memberReducers.updateRecipientId(state, action);
        // twilio SDK
        case Types.UPDATE_ACCESS_TOKEN:
            return twilioReducers.updateAccessToken(state, action);
        case Types.UPDATE_CLIENT:
            return twilioReducers.updateClient(state, action);
        case Types.UPDATE_CHANNEL:
            return channelReducers.updateChannel(state, action);
        // messages
        case Types.UPDATE_MESSAGES:
            return messageReducers.updateMessages(state, action);
        case Types.NEW_MESSAGE:
            return messageReducers.newMessage(state, action);
        case Types.RESET_HAS_CUSTOMER_ADDED_NEW_MESSAGE:
            return messageReducers.resetHasCustomerAddedNewMessage(state);
        case Types.UDPATE_HAS_NEW:
            return messageReducers.updateHasNew(state, action);
        case Types.UPDATE_FETCH_MORE_METHOD:
            return messageReducers.updateFetchMoreMethod(state, action);
        case Types.UPDATE_FETCH_MORE_MESSAGES:
            return messageReducers.updateFetchedMoreMessages(state, action);
        case Types.UPDATE_MARK_READ_METHOD:
            return messageReducers.updateMarkReadMethod(state, action);
        case Types.UPDATE_HAS_MORE:
            return messageReducers.updateHasMore(state, action);
        // members
        case Types.UPDATE_MEMBERS:
            return memberReducers.updateMembers(state, action);
        case Types.TYPING_STARTED:
        case Types.TYPING_ENDED:
            return memberReducers.updateTyping(state, action);
        // user
        case Types.UPDATE_FETCH_MORE_STATUS:
            return userReducers.updateFetchingMoreStatus(state, action);
        // utils
        case Types.LOADING:
            return otherReducers.updateLoading(state, action);
        case Types.UPDATE_ERROR:
            return otherReducers.updateError(state, action);
        case Types.START_BOT_TYPING:
            return otherReducers.startLendiBotTyping(state);
        case Types.STOP_BOT_TYPING:
            return otherReducers.stopLendiBotTyping(state);
        default:
            // eslint-disable-next-line no-console
            console.warn('lendi-chat: unhandled reducer: ', action);
            return state;
    }
}
//# sourceMappingURL=index.js.map